import { useAccountListQuery } from "./hooks/useAccountListQuery";
import { FormControl, Grid, MenuItem, Select, Typography } from "@mui/material";
import { RectangularSkeleton } from "../../components/RectangularSkeleton";
import { useCallback, useContext, useEffect, useState } from "react";
import { appContext } from "../../context/AppContext";

export function AccountSelector() {
  const query = useAccountListQuery();
  const [accountId, setAccountId] = useState<string>(undefined);
  const { setAppConfig } = useContext(appContext);
  useEffect(() => {
    if (query.isSuccess) {
      setAccountId(query.data?.accounts[0].id);
      setAppConfig((prevState) => ({
        ...prevState,
        accountId: query.data?.accounts[0].id,
      }));
    }
  }, [query.data]);
  const onChange = useCallback((accountId: string) => {
    setAccountId(accountId);
    setAppConfig((prevState) => ({ ...prevState, accountId: accountId }));
  }, []);

  return (
    <Grid item container>
      {query.isSuccess ? (
        <FormControl variant={"standard"}>
          <Select
            labelId={"account-select"}
            value={accountId || ""}
            role={"combobox"}
            onChange={(event) => onChange(event.target.value)}
          >
            {query.data?.accounts.map((account) => (
              <MenuItem key={account.code} value={account.id}>
                <Typography
                  variant={"h4"}
                  color={"primary.main"}
                  sx={{
                    fontWeight: "bold",
                    width: "300px",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {account.name}
                </Typography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : query.isLoading ? (
        <RectangularSkeleton
          height={"2em"}
          width={"200px"}
          ariaLabel={"Loading Accounts"}
        />
      ) : (
        <RectangularSkeleton
          height={"2em"}
          width={"200px"}
          ariaLabel={"Error Loading Accounts"}
        />
      )}
    </Grid>
  );
}
